/**
 * 아임포트 본인인증 가맹점 번호
 */
// eslint-disable-next-line import/prefer-default-export
export const CERTIFICATION_STROE_CODE = 'imp92591041';
